'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PassiveCar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CarHeader = require('./CarHeader.jsx');

var _CarHeader2 = _interopRequireDefault(_CarHeader);

var _CarCompany = require('./CarCompany.jsx');

var _CarCompany2 = _interopRequireDefault(_CarCompany);

var _CarInfoPanel = require('./CarInfoPanel.jsx');

var _CarInfoPanel2 = _interopRequireDefault(_CarInfoPanel);

var _CarTypeDescriptionPanel = require('./CarTypeDescriptionPanel.jsx');

var _CarTypeDescriptionPanel2 = _interopRequireDefault(_CarTypeDescriptionPanel);

var _CarTotalFooter = require('./CarTotalFooter.jsx');

var _CarTotalFooter2 = _interopRequireDefault(_CarTotalFooter);

var _Disclaimer = require('../../../../common/Disclaimer');

var _Disclaimer2 = _interopRequireDefault(_Disclaimer);

var _emailStyleTools = require('helpers/emailStyleTools');

var _basketHelpers = require('helpers/basketHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTypeDescription = function getTypeDescription(option) {
  return option.carOption.carTypeDescription;
};

function PassiveCar(_ref) {
  var components = _ref.components,
      option = _ref.option,
      optionNumber = _ref.optionNumber;

  var styleCarCommentContainer = (0, _emailStyleTools.containerStyles)(components, 'CarCommentContainer');
  var styleCarComment = (0, _emailStyleTools.textStyles)(components, 'CarComment');
  var renderDisclaimer = function renderDisclaimer(optionPrice) {
    var text = (0, _basketHelpers.getDisclaimerText)(optionPrice);
    if (text) {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Disclaimer2.default, { padTen: _emailStyleTools.padTen,
            containerStyle: styleCarCommentContainer,
            textStyle: styleCarComment,
            text: text
          })
        )
      );
    } else {
      return '';
    }
  };

  //TODO change company name and put the real information from JSON
  return _react2.default.createElement(
    'table',
    { style: { width: '100%' } },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_CarHeader2.default, { components: components, text: 'Option ' + (optionNumber + 1) })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_CarCompany2.default, { components: components, text: 'COMPANY NAME' })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_CarInfoPanel2.default, { components: components, option: option.carOption })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_CarTypeDescriptionPanel2.default, { components: components, text: getTypeDescription(option) })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_CarTotalFooter2.default, { components: components, option: option.optionPrice })
        )
      ),
      renderDisclaimer(option.optionPrice)
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Passive/PassiveCar.jsx
// module id = 1507
// module chunks = 0